import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const ShopifyAppConnect = () => import('@/views/shopify/AppConnect')
const BoughtTogetherApp = () => import('@/views/shopify/bought-together-app/BoughtTogetherApp')

//ShopO
const ShopoPredictCategory = () => import('@/views/shopo/predict-category/AppContainer')
const ShopoSimilarProducts = () => import('@/views/shopo/similar-products/AppContainer')

Vue.use(Router)


export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      //redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'shopify',
          redirect: '/shopify/app/bought-together',
          name: 'Shopify',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'app/bought-together',
              name: 'Frequently Bought Together App',
              component: BoughtTogetherApp
            },
            {
              path: 'connect/:appname/:code',
              name: 'Connect Shopify Store',
              component: ShopifyAppConnect
            }
          ]
        },
        {
          path: 'shopo',
          name: 'ShopO',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'app/category-predict',
              name: 'Predict Category Demo',
              component: ShopoPredictCategory
            },
            {
              path: 'app/similar-products',
              name: 'Similar Products Demo',
              component: ShopoSimilarProducts
            }
          ]
        }
      ]
    }]
});
